// Petit module qui expose l'email du user courant à l'interceptor axios.
// Ne stocke rien dans localStorage (l'identité reste en mémoire), c'est juste
// un canal pour permettre à api.js (hors React) de lire l'email résolu par
// AuthContext.

let currentUserEmail = null;

export function setCurrentUserEmail(email) {
    currentUserEmail = email || null;
}

export function getCurrentUserEmail() {
    return currentUserEmail;
}
